<template>
  <div class="text-xs-center">
    <div style="position: fixed;height: 100%;width: 100%;top: 0;right: 0;z-index: 1000;background: rgba(0,0,0,0.5);display: flex;justify-content: center;align-items: center;">
      <div style="width:300px">
        <v-card
          color="primary"
          dark
        >
          <v-card-text class="pt-2">
            {{$store.getters.loaderMessage}}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isLoading: true,
      isFullPage: true,
      dialog: true
    }
  }
}
</script>
<style scoped>
.v-overlay {
    z-index: 10000!important;
}
.v-dialog__content {
    z-index: 10002!important;
}
</style>



// WEBPACK FOOTER //
// src/View/components/Loader.vue